import { useMemo } from "react"
import { useFormikContext } from "formik"
import {
    ConfigQuery,
    fetchMeetingServiceConfiguration,
    MeetingServiceConfigurationResponse,
} from "../../createOrderApi"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { MeetingServicePriceListState } from "../../createOrderTypes"
import { CreateOrderType } from "../../helpers"
import { useCreateOrderForm } from "../../mainForm/CreateOrderFormContext"
import { LoadingSpinner } from "../../../loading/LoadingSpinner"
import { MeetingServiceForm } from "./MeetingServiceForm"
import { MeetingServiceOrder } from "../../../../../modules/merchant/accounting/accounting/accountingTypes"
import { DynamicConfigKey, DynamicMainFormValues, MainOrderFormikRef, MeetingServiceTabValues } from "../form/formTypes"
import { ensurePaymentMethod, findGroupByFieldKey } from "../form/helpers"

export const selectMeetingServiceConfig = (data: MeetingServiceConfigurationResponse) => {
    if (data?.meetingServiceConfig) {
        const { meetingServiceConfig } = data
        if (
            findGroupByFieldKey(meetingServiceConfig.sections, DynamicConfigKey.PAYMENT_METHOD)?.fields.find(
                (el) => el.key === DynamicConfigKey.PAYMENT_METHOD,
            )?.active
        ) {
            return meetingServiceConfig
        } else {
            return ensurePaymentMethod(meetingServiceConfig)
        }
    } else return undefined
}

type MeetingServiceFormContainerProps = Readonly<{
    handleOpenSelectPriceListsDialog: () => void
    orderDetails?: MeetingServiceOrder
    handleSubmitMeetingService: (values: MeetingServiceTabValues) => void
    outerFormik: MainOrderFormikRef
}>

export function MeetingServiceFormContainer({
    handleOpenSelectPriceListsDialog,
    orderDetails,
    handleSubmitMeetingService,
    outerFormik,
}: MeetingServiceFormContainerProps) {
    const { user, handleClose, dialogType, flowConfig, orderContext } = useCreateOrderForm()
    const { values } = useFormikContext<DynamicMainFormValues>()
    const priceList: MeetingServicePriceListState = values["priceList"]

    const merchantId = priceList.item?.merchantId || 0
    const configQueryDeps = useMemo(() => {
        return { userId: user.userId, merchantId }
    }, [user.userId, merchantId])

    const { data: meetingServiceConfiguration, isLoading } = useApiQuery(fetchMeetingServiceConfiguration, {
        queryName: ConfigQuery.MEETING_SERVICE_CONFIG,
        dependencies: configQueryDeps,
        enabled: !!merchantId,
        select: selectMeetingServiceConfig,
        useErrorBoundary: true,
    })

    if (isLoading || !outerFormik.current) {
        return <LoadingSpinner />
    }

    return (
        <MeetingServiceForm
            user={user}
            handleClose={handleClose}
            dialogType={dialogType}
            handleOpenSelectPriceListsDialog={handleOpenSelectPriceListsDialog}
            flowConfig={flowConfig}
            meetingServiceConfiguration={meetingServiceConfiguration}
            orderDetails={orderDetails}
            mainValues={values}
            orderContext={orderContext}
            handleSubmitMeetingService={handleSubmitMeetingService}
            outerFormik={outerFormik}
        />
    )
}
